import React from 'react';
import AceEditor from 'react-ace';

import 'brace/mode/html';
import 'brace/mode/css';
import 'brace/mode/javascript';
import 'brace/theme/github';
import 'brace/ext/language_tools';

import Typography from '@material-ui/core/Typography';

const styles = {
  border: '1px solid rgba(178,178,178,0.5)',
  borderRadius: '3px',
  backgroundColor: '#FFFFFF',
  marginBottom: '17px',
  lineHeight: '16px',
};

function debounce(fn, delay) {
  let timer = null;

  return function () {
    const context = this, args = arguments;
    clearTimeout(timer);
    timer = setTimeout(function () {
      fn.apply(context, args);
    }, delay);
  };
}

export class MarkupEditor extends React.Component {
  constructor(props) {
    super(props);
  }

  onChange = debounce((markup) => typeof this.props.onChange === 'function' && this.props.onChange(markup), 500);

  onLoad = () => {};

  render() {
    return <div>
      <Typography>{this.props.label}</Typography>
      <AceEditor
        mode={this.props.mode}
        theme='github'
        name='test'
        height='184px'
        width='100%'
        onLoad={this.onLoad}
        onChange={this.onChange}
        fontSize={12}
        showPrintMargin={false}
        showGutter={true}
        highlightActiveLine={true}
        value={this.props.value || ''}
        editorProps={{
          $blockScrolling: true
        }}
        setOptions={{
          enableBasicAutocompletion: true,
          enableLiveAutocompletion: true,
          enableSnippets: true,
          showLineNumbers: false,
          tabSize: 2,
        }}
        style={styles} />
      </div>
  }
}

export const RenderMarkupEditor = ({input, ...rest}) => <MarkupEditor {...input} {...rest}/>
